
export default {
	namespaced: true,
	state () {
		return {
			permissions: []
		}
	},
	mutations: {
		permissions(state, permissions)
		{
			state.permissions = permissions;
		},

		can: (state) => (permission) => {
			return state.permissions.includes(permission);
		},

	},
	getters: {
		/**
		 *
		 * @param state
		 * @returns {[string]}
		 */
		permissions(state)
		{
			return state.permissions;
		},
		can: (state) => (permission) => {
			return state.permissions.includes(permission);
		},
	},
	actions:{
		permissions(store, permissions)
		{
			store.commit('permissions', permissions);
		},
	}
}